/**
 * @module: 选中的用户
 * @author: Teacher Tang
 * @date: 2019-11-01 10:53:03
 */

import React, { useState } from 'react';
import { IMembersSel } from '@src/entity/company/project';
import { Drawer } from 'antd-mobile';
import { Header, Empty } from '@ywk/mobile-components';
import './style.less';

const SelectUsers = (props: {
  users: IMembersSel[];
  show: boolean;
  title?: string;
  cancelCallback: Function;
  okCallback: Function;
}) => {
  const [curUsers, setUserFn] = useState<IMembersSel[]>(props.users);

  /** 移除选中的用户 */
  const removeFn = (idx: number) => {
    const items = Object.assign([], curUsers);
    items.splice(idx, 1);
    setUserFn(items);
  };

  /** 确定操作 */
  const okFn = () => {
    props.okCallback(curUsers);
  };

  function fullSideBar() {
    return (
      <section className="select-user-page">
        <Header
          leftContent={<span>取消</span>}
          icon={<span></span>}
          rightContent={<span onClick={okFn}>确定</span>}
          onLeftClick={() => {
            props.cancelCallback();
          }}
        >
          {props.title || '选择下属'}
        </Header>
        {curUsers.map((member: IMembersSel, idx: number) => {
          return (
            <div className="user-item" key={member.uuid}>
              <div className="user-info">
                <img src={member.avatar} alt={member.name} />
                <span>{member.name}</span>
              </div>
              <img
                onClick={() => removeFn(idx)}
                src={require('./imgs/close-circle-del.png')}
                className="user-del"
                alt=""
              />
            </div>
          );
        })}
        {curUsers.length === 0 ? (
          <div style={{ height: 400 }}>
            <Empty txt="没有选中用户" />
          </div>
        ) : null}
      </section>
    );
  }

  return (
    <Drawer open={props.show} position="bottom" sidebar={fullSideBar()} className="full-sidebar">
      {' '}
    </Drawer>
  );
};

export default SelectUsers;
